function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Anchor } from '../Anchor';
import { Box } from '../Box';
export var SkipLink = function SkipLink(_ref) {
  var id = _ref.id,
      label = _ref.label,
      rest = _objectWithoutPropertiesLoose(_ref, ["id", "label"]);

  return React.createElement(Box, {
    margin: "small"
  }, React.createElement(Anchor, _extends({
    href: "#" + id,
    label: label
  }, rest)));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet/es6/components/SkipLink/SkipLink.js
// module id = 503
// module chunks = 0